import { useEffect, useRef, useState } from 'react';
import { Api } from '../../services/api';
import { Modal } from '../../Components/Modal';
import { OffCanvas } from '../../Components/OffCanvas';
import { CargaCanvas } from '../../Components/CargaCanvas';
import { LoadingCubeComponent } from '../../Components/LoadingCubeComponent';
import { MontarCarga } from './Modal/MontarCarga';

export const Carga2 = () => {
  const [cargas, setCargas] = useState(null);
  const [cargasSAP, setCargasSAP] = useState(null);
  const [cargaSelected, setCargaSelected] = useState(null);
  const [tokenSearch, setTokenSearch] = useState(null);
  const [isFindCargas, setIsFindCargas] = useState(false);

  const [searchCarga, setSearchCarga] = useState('');
  const inputToken = useRef(null);

  const [isModalOpen, setModalOpen] = useState(false);

  const findCargasSAP = async (limit, offset) => {
    try {
      const cargaSAP = await Api.get(`/etl/carga/all?limit=${limit}&offset=${offset}`);
      console.log(cargaSAP);
      setCargasSAP(cargaSAP.data);
    } catch (e) {
      setCargasSAP(null);
    } finally {
      setIsFindCargas(true);
    }
  };

  const findAllCargas = async () => {
    try {
      const carga = await Api.get('/carga');
      console.log(carga);
      setCargas(carga.data);
    } catch (e) {
      setCargas(null);
    }
  };

  const refreshCargas = async () => {
    setCargas(null);
    setCargasSAP(null);
    await findAllCargas();
    await findCargasSAP(10, 1);
    setSearchCarga('');
  };

  const handleClickSearchToken = async () => {
    const id = inputToken.current.value;
    try {
      const token = await Api.get(`/token/${id}`);

      console.log(token);

      setTokenSearch(token.data);
      tokenSearch;
    } catch (e) {
      setTokenSearch(null);
    }
  };

  const handleClickAtribuirCarga = async () => {
    try {
      await Api.post(`/token/carga/${cargaSelected}`, {
        id: inputToken.current.value,
      });

      alert('Carga atribuida com sucesso!');
      setTokenSearch(null);
      inputToken.current.value = '';
    } catch (e) {
      console.log(e.message);
    }
  };

  const selectCarga = (id) => {
    setCargaSelected(null);
    setCargaSelected(id);
  };

  const searchCanhoto = async () => {
    setIsFindCargas(false);
    setCargas(null);
    setCargasSAP(null);
    try {
      const resp = await Api.get(`/etl/carga/${searchCarga}`);

      console.log(resp.data);

      setCargas(null);
      setCargasSAP(resp.data);
    } catch (e) {
      setCargas(null);
      setCargasSAP(null);
    } finally {
      setSearchCarga('');
      setIsFindCargas(true);
      console.log(cargasSAP);
    }
  };

  const inicializaCarga = async (carga) => {
    console.log('Inicializa carga', carga);
    try {
      const resp = await Api.post('/carga/create', {
        ...carga,
        numero: carga.cod_carga,
        idStatus: 2,
      });

      console.log('Resultado:', resp.data);

      const nf = await Api.get(`/etl/canhoto/${resp.data.cod_carga}`);

      for (let v of nf.data) {
        Api.post('/canhoto/create', {
          latitude: '',
          longitude: '',
          nf: `${v.nota_fiscal}`,
          arquivo: '',
          idCarga: `${resp.data.id}`,
        });
        console.log(v);
      }

      findAllCargas();
      findCargasSAP(10, 1);
    } catch (e) {
      console.log('Segue erro:', e.message);
    }
  };

  useEffect(() => {
    if (!isModalOpen) {
      findAllCargas();
      findCargasSAP(10, 1);
    }
  }, [isModalOpen]);

  return (
    <div className="mt-4 container">
      <div className="mt-4"></div>
      <div className="row">
        <div className="col-7">
          {/* <button className="btn btn-success" data-bs-toggle="modal" data-bs-target="#create-carga-modal">
            Montar Carga
          </button> */}
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar carga"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
              value={searchCarga}
              onChange={(e) => setSearchCarga(e.target.value)}
            />
            <button className="input-group-text btn btn-success" onClick={searchCanhoto}>
              Procurar
            </button>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-2">
          <button className="btn btn-success" onClick={refreshCargas}>
            Atualizar
          </button>
        </div>
      </div>
      <br />
      <div style={{ maxHeight: '78vh', overflowY: 'visible', overflowX: 'hidden' }}>
        <LoadingCubeComponent isLoading={isFindCargas} />
        <table className="table mt-2">
          <thead>
            <tr>
              <th scope="col">Carga</th>
              <th scope="col">Cliente</th>
              <th scope="col">Empresa</th>
              <th scope="col">Status</th>
              <th scope="col">-</th>
            </tr>
          </thead>
          <tbody>
            {cargas &&
              cargas.map((carga) => (
                <tr key={carga.id}>
                  <th scope="row">{carga.cod_carga}</th>
                  <td>{carga.nome_cliente}</td>
                  <td>
                    {carga.cod_empresa == 1000
                      ? 'SR Embalagens Barretos'
                      : carga.cod_empresa == 1100
                      ? 'SR Embalagens Três Rios'
                      : carga.cod_empresa == 2000
                      ? 'Barreflex Barretos'
                      : carga.cod_empresa == 2100
                      ? 'Barreflex Sumaré'
                      : ''}
                  </td>
                  <td>{carga.status.descricao}</td>
                  <td>
                    <button
                      className="btn btn-secondary"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvas-view-carga"
                      onClick={() =>
                        selectCarga({
                          id: carga.id,
                          status: carga.status.descricao,
                        })
                      }
                    >
                      Ver status
                    </button>
                    {/* )} */}
                  </td>
                </tr>
              ))}

            {cargasSAP &&
              cargasSAP.map((carga) => (
                <tr key={carga.cod_carga}>
                  <th scope="row">{carga.cod_carga}</th>
                  <td>{carga.nome_cliente}</td>
                  <td>
                    {carga.cod_empresa == 1000
                      ? 'SR Embalagens Barretos'
                      : carga.cod_empresa == 1100
                      ? 'SR Embalagens Três Rios'
                      : carga.cod_empresa == 2000
                      ? 'Barreflex Barretos'
                      : carga.cod_empresa == 2100
                      ? 'Barreflex Sumaré'
                      : ''}
                  </td>
                  <td>-</td>
                  <td>
                    {/* <button className="btn btn-outline-success" onClick={() => inicializaCarga(carga)}>
                      Montar
                    </button> */}
                    <MontarCarga inicializa={inicializaCarga} carga={carga} />
                  </td>
                </tr>
              ))}

            {!cargas && !cargasSAP && !isFindCargas && <td>Não foi encontrado nenhuma carga</td>}
          </tbody>
        </table>
      </div>
      <Modal
        data={{
          ref: 'atribuir-token-carga',
          title: 'Atribuir um token a carga',
          isModalOpen: setModalOpen,
        }}
      >
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Pesquise pelo número do token"
            aria-label="Pesquise pelo número do token"
            aria-describedby="button-addon2"
            ref={inputToken}
          />
          <button
            className="btn btn-outline-secondary"
            type="button"
            id="button-addon2"
            onClick={handleClickSearchToken}
          >
            Pesquisar
          </button>
        </div>
        <div>
          <table className="table mt-4">
            <thead>
              <tr>
                <th scope="col">Chave</th>
                <th scope="col">Motorista</th>
                <th scope="col">Transportadora</th>
                <th scope="col">Descrição</th>
                <th scope="col">-</th>
              </tr>
            </thead>
            <tbody>
              {tokenSearch ? (
                <tr key={tokenSearch.id}>
                  <th scope="row">{tokenSearch.id}</th>
                  <td>{tokenSearch.motorista}</td>
                  <td>{tokenSearch.transportadora}</td>
                  <td>{tokenSearch.descricao}</td>
                  <td>
                    <button className="btn btn-success" onClick={handleClickAtribuirCarga}>
                      👍
                    </button>
                  </td>
                </tr>
              ) : (
                <tr key={1}>
                  <th scope="row">-</th>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>
                    <button className="btn btn-success" onClick={handleClickAtribuirCarga}>
                      -
                    </button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal>

      <OffCanvas
        data={{
          key: 'view-carga',
          title: `Status da Carga${cargaSelected ? ' - ' + cargaSelected.status : ''}`,
        }}
        handleClose={() => {
          setCargaSelected(null);
        }}
      >
        {cargaSelected && <CargaCanvas id={cargaSelected.id} />}
      </OffCanvas>
    </div>
  );
};
